
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exempel-datadriven-transformation",
      function () {
        return require("private-next-pages/exempel-datadriven-transformation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exempel-datadriven-transformation"])
      });
    }
  